import * as React from "react";
import { Redirect, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logOut } from "../../store/modules/authSlice";
import { useEffect } from "react";
import { RootState } from "../../store/rootReducer";
import AutoLogout from "../auth/AutoLogout";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import { redirectForSMADriver, isSMADriver } from "./DriverRouteRedirects";
import IAuthState from "../../interfaces/IAuthState";
import { consts } from "../../common/consts";

const isCorrectlyAuthenticated = (authStore: IAuthState, permissions: any, userPermissions: string[]): boolean => {
  const nowInUnixTime = Math.floor(new Date().getTime() / 1000);
  var _permissions = permissions?.split(",");
  return authStore.isAuthenticated &&
    authStore.data !== null &&
    authStore.data.exp > nowInUnixTime &&
    (permissions === null ||
      permissions === undefined ||
      permissions === "" ||
      (
       (_permissions.includes(consts.Permissions.SMAMakeBooking) || _permissions.includes(consts.Permissions.MakeBooking)) 
       ||  (userPermissions ===undefined ||userPermissions === null || userPermissions.some((p) => userPermissions.includes(p)) )
      ) 
      ||
      userPermissions.some((p) => permissions.split(",").includes(p)) ||
      authStore.data.IsAdmin)
    ? true
    : false;
};

const PrivateRoute = ({ component, permissions, ...rest }: any) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
  const { authStore } = useSelector((state: RootState) => state);
  useEffect(() => {
    return function () {
      let nowInUnixTime = Math.floor(new Date().getTime() / 1000);
      if (authStore.isAuthenticated && authStore.data !== null && authStore.data.exp < nowInUnixTime) {
        dispatch(logOut());
      }
    };
  }, []);

  const routeComponent = (props: any) => {
    const userPermissions = authStore.data?.role.split(",") ?? [];
    if (isCorrectlyAuthenticated(authStore, permissions, userPermissions)) {
      if (isSMADriver(userPermissions)) {
        return redirectForSMADriver(authStore, dispatch, component, props);
      } else {
        return (
          <>
            <AutoLogout />
            {React.createElement(component, props)}
          </>
        );
      }
    } else {
      const isLogOut = localStorage.getItem("isLogOut");
      if (isLogOut !== "true") {
        //localStorage.setItem("pageToGoAfterLogin", window.location.pathname);
      } else {
        localStorage.removeItem("isLogOut");
      }
      return <Redirect to={{ pathname: "/login" }} />;
    }
  };
  return <Route render={routeComponent} {...rest} />;
};

export default PrivateRoute;
